exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: inline-block; }\n\n.avatar-wrapper {\n  font-size: 24px;\n  width: 1em;\n  height: 1em;\n  border-radius: 1em;\n  overflow: hidden;\n  position: relative; }\n  .avatar-wrapper:hover .initials {\n    opacity: 1; }\n\na {\n  display: inline-block; }\n\nimg {\n  max-width: 100%;\n  height: auto; }\n\n.initials {\n  opacity: 0;\n  transition: opacity 0.25s ease;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  text-align: center;\n  font-size: 0.5em;\n  line-height: 2em;\n  background: #4285F4;\n  color: white;\n  text-transform: uppercase; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/user-avatar/user-avatar.component.scss
// module id = ../../../../../src/app/user-avatar/user-avatar.component.scss
// module chunks = main